import { BreakpointMinService } from 'src/app/@utils/breakpoint-min.service';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductDetailViewModel } from '@models/api-search.models';
import { ImageVariant, ProductImageComponent } from '@shared/image/product-image/product-image.component';
import { WithNegativeSignPipe } from '@shared/price-pipes/with-negative-sign.pipe';
import { NormalizePropertiesPipe } from '@shared/product-details-pipes/normalize-properties.pipe';
import { IsDimensionPropertyPipe } from '@shared/product-details-pipes/is-dimension-property.pipe';
import { RemoveTrailingZeroesPipe } from '@shared/price-pipes/remove-trailing-zeroes.pipe';
import { FormatCurrencyPipe } from '@shared/price-pipes/format-currency.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { SetIsFocusedDirective } from '@shared/is-focused/is-focused.directive';
import { AsyncPipe, KeyValuePipe, NgClass, NgIf } from '@angular/common';
import { ProductSplashComponent } from '@features/product/product-splash/product-splash.component';
import { ColorStringToHexPipe } from '@shared/product-details-pipes/color-string-to-hex.pipe';
import { ActiveSplashPipe } from '@features/product/pipes/active-splash.pipe';

@Component({
    selector: 'app-product-mini',
    templateUrl: './product-mini.component.html',
    styleUrls: ['./product-mini.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        NgIf,
        ProductImageComponent,
        SetIsFocusedDirective,
        RouterLink,
        AsyncPipe,
        KeyValuePipe,
        TranslateModule,
        TranslateSafePipe,
        FormatCurrencyPipe,
        RemoveTrailingZeroesPipe,
        IsDimensionPropertyPipe,
        NormalizePropertiesPipe,
        WithNegativeSignPipe,
        ProductSplashComponent,
        ColorStringToHexPipe,
        ActiveSplashPipe
    ]
})
export class ProductMiniComponent {
    @Input() product: ProductDetailViewModel;

    @Input() quantity: number = 1;

    @Input() show: {
        properties?: boolean;
        price?: boolean;
        points?: boolean;
        discount?: boolean;
    };

    @Input() linkToProduct: boolean = false;

    @Input() imageVariant: ImageVariant = 'gray-tint';

    @Output() public readonly productClicked = new EventEmitter<void>();

    constructor(public readonly breakpointServiceMin: BreakpointMinService) {}
}
